export class MockSessionStorage {
  get = jasmine.createSpy('get');
  set = jasmine.createSpy('set');
  remove = jasmine.createSpy('remove');
}
